// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2qxP4","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2WW50","obliqueLine":"membershipbadge_obliqueLine__19XQk"};